import * as React from 'react';
import { StatCard } from './StatCard';
import { useEchoStatsQuery } from '@/hooks/useEchoStatsQuery';
import { useEchoEarningsQuery } from '@/hooks/useEchoEarningsQuery';
import { formatCompactNumber, formatEur } from '@/utils/formatters';
import type { EchoProfileResponse } from '@/types/echo_creation';

// Import Assets
import starIcon from '@/assets/images/svg/star.svg';
import revenueIcon from '@/assets/images/svg/revenue_icon.svg';
import sessionIcon from '@/assets/images/svg/session_icon.svg';
import clickIcon from '@/assets/images/svg/click_icon.svg';

interface StatsRowProps {
  echo: EchoProfileResponse;
}

export const StatsRow: React.FC<StatsRowProps> = ({ echo }) => {
  const { data: stats } = useEchoStatsQuery(echo.id);
  const { data: earnings } = useEchoEarningsQuery(echo.id);

  const likes = stats?.total_super_likes ?? echo.total_fans ?? 0;
  const formattedLikes = formatCompactNumber(likes);

  const msgCount = stats?.total_messages ?? 0;
  const totalMessages = formatCompactNumber(msgCount);

  const revenue = formatEur(earnings?.total_amount_earned ?? 0);

  return (
    <div className='grid grid-cols-2 gap-4 lg:flex lg:w-full lg:flex-row lg:justify-between'>
      <div className='w-full lg:flex-1'>
        <StatCard title='Stars' value={formattedLikes} iconSrc={starIcon} />
      </div>
      <div className='w-full lg:flex-1'>
        <StatCard title='Revenue Generated' value={revenue} iconSrc={revenueIcon} />
      </div>
      <div className='w-full lg:flex-1'>
        <StatCard title='Total Messages' value={totalMessages} iconSrc={sessionIcon} />
      </div>
      <div className='w-full lg:flex-1'>
        {/* Using Click Rate as the 4th metric since Growth is not in API */}
        <StatCard title='Click Rate' value={`${echo.click_rate ?? 0}%`} iconSrc={clickIcon} />
      </div>
    </div>
  );
};
